<template>
  <div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px"
             class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="发布选项:"
                        prop="status">
            <el-radio-group fill="#FD9112"
                            v-model="ruleForm.status">
              <el-radio label="0">草稿</el-radio>
              <el-radio label="1">立刻发布</el-radio>
              <el-radio label="2">定时发布</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否推荐:"
                        prop="isRecommend">
            <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                            v-model="ruleForm.isRecommend"
                            size="small">
              <el-radio-button label="1">是</el-radio-button>
              <el-radio-button label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="笔名:"
                        prop="isRecommend">
            <el-input v-model="penName"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="ruleForm.status == 2"
                :span="6">
          <el-form-item label="定时发布:"
                        prop="releaseAt">
            <el-date-picker v-model="ruleForm.releaseAt"
                            type="datetime"
                            style="width:100%;"
                            value-format="timestamp"
                            placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题:"
                        prop="title">
            <el-input v-model="ruleForm.title"
                      placeholder="必填，不能超过40个字"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="推送栏目:"
                        prop="columnId">
            <el-select style="width:100%;"
                       v-model="ruleForm.columnId"
                       
                       placeholder="请选择">
              <template v-for="item in columnList">
                <el-option style="width:100%;"
                           v-if="item.level == 1"
                           disabled
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
                <template v-if="item.children.length > 0">
                  <el-option style="width:100%;"
                             v-for="c in item.children"
                             :key="c.value"
                             :label="c.label"
                             :value="c.value"
                             v-html="'<span style=color:#303030;>'+c.label+'</span>'">
                    <span style="margin-left:30px;">{{ '∟' + c.label}}</span>
                  </el-option>
                </template>
              </template>

            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-form-item prop="desc">
          <div slot="label"
               class="labelclass">
            简介:
            <!-- <p>
                <span @click="quickFormat" style="color:#185ED3;cursor: pointer;">一键排版<span style="opacity: 0;">:</span></span>
              </p> -->
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 5, maxRows: 7}"
                    v-model="ruleForm.desc"
                    show-word-limit
                    maxlength="200"
                    placeholder="选填，不超过200个字"></el-input>
        </el-form-item>
      </el-row>
      <el-row style="margin-bottom:10px;">
        <el-form-item prop="textValue">
          <div slot="label"
               class="labelclass">
            正文:
          </div>
          <el-input type="textarea"
                    show-word-limit
                    :autosize="{ minRows: 5, maxRows: 7}"
                    v-model="ruleForm.textValue"
                    maxlength="500"
                    placeholder="选填，不超过500个字"></el-input>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="picbj">
      <div class="picanddesc"
           v-dragging="{ item: e, list: choosePic, group: 'item' }"
           v-for="(e,i) in choosePic"
           :key="i">
        <!-- <div class="demo-image__preview"> -->
        <!-- </div> -->
        <div class="pic">
          <!-- :style="{backgroundImage:'url(' + e.src +')'}"> -->
          <el-image :preview-src-list="[e.srcW1080 ? e.srcW1080 : e.fileInfo.srcW1080]"
                    :src="e.src">
          </el-image>
          <!-- 设为封面 -->
          <el-tooltip class="item"
                      effect="dark"
                      content="设为封面"
                      placement="top">
            <div class="fm">
              <img width="20"
                   @click="picFm(e,i)"
                   src="@/assets/picbrowse/book.png"
                   alt="">
            </div>
          </el-tooltip>

          <!-- 删除 -->
          <el-tooltip class="item"
                      effect="dark"
                      content="删除"
                      placement="top">
            <div class="delete">
              <img width="20"
                   @click="picDelete(e,i)"
                   src="@/assets/picbrowse/delete.png"
                   alt="">
            </div>
          </el-tooltip>

          <div v-show="ruleForm.indexpicFileId == e.id"
               class="fengmian">
            <img width="20"
                 src="@/assets/picbrowse/bookhover.png"
                 alt="">
          </div>
        </div>
        <!-- {{e.desc}} -->
        <el-input maxlength="100"
                  show-word-limit
                  style="margin-left:30px;width:180px;"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6}"
                  v-model="e.desc"
                  placeholder="图片说明，100个字以内"></el-input>
      </div>
    </div>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isSimple ? '#E27B02' : '#194897'}"
                   type="primary">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  listAtlasPictures, getPictures
} from "@/api/picture";
import {
  listWebsiteColumn,
  addWebsiteShowInfo,
  getWebsiteShowInfo,
  updateWebsiteShowInfo
} from "@/api/website";
import { setUserSetting } from "@/api/config";
import { getDate } from "@/plugins/getdate";
import { mapGetters, mapActions } from 'vuex'
// import { mapGetters } from "vuex";
import { updatePictureActivityArticle, getPictureActivityArticle } from '@/api/pictureActivityArticle'
import { picPrefix } from "@/constants/piccommon";
import {
  listAuthRole
} from "@/api/authRole";
export default {
  data () {
    return {
      picPrefix,
      isAct: '',
      choosePic: [],
      roleName: [],
      columnList: [],
      ruleForm: {
        status: '1',
        releaseAt: '',
        title: '',
        content: {
          "text": '',
          "imageList": []
        },
        columnId: '',
        isRecommend: '0',
        desc: '',
        textValue: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择发布选项', trigger: 'blur' }
        ],
        releaseAt: [
          { required: true, message: '请选择日期', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'change' },
          { min: 1, max: 40, message: '长度不得超过40个字符', trigger: 'blur' }
        ],
        columnId: [
          { required: true, message: '请选择推送栏目', trigger: 'blur' }
        ],
        desc: [
          { min: 0, max: 200, message: '长度不得超过200个字符', trigger: 'blur' }
        ]
      },
      penName: '',
      activityArticleInfo: ''
    };
  },
  computed: {
    ...mapGetters(["createUid"])
  },
  methods: {
    ...mapActions(["setLoveList"]),
    async updatePictureActivityArticleAsync (val) {
      let { status, data } = await updatePictureActivityArticle(val)
    },
    async getPictureActivityArticleAsync () {
      let { status, data } = await getPictureActivityArticle(this.$route.query.activityArticleId)
      if (status) {
        this.ruleForm.title = data.title
        this.ruleForm.textValue = data.content
      }
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.activityArticleId) {
            let activityArticleInfo = JSON.parse(localStorage.getItem('activityArticleInfo'))
            // console.log(activityArticleInfo);
            let val = {
              // content: activityArticleInfo.content,
              // createAt: activityArticleInfo.createAt,
              // createUid: activityArticleInfo.createUid,
              // checkUid: this.createUid,
              id: parseInt(this.$route.query.activityArticleId),
              isCheck: 1,
              pictureActivityId: activityArticleInfo.pictureActivityId,
              // pictureCount: activityArticleInfo.pictureCount,
              pictureIds: activityArticleInfo.pictureIds,
              status: activityArticleInfo.status,
              title: activityArticleInfo.title,
              // updateAt: activityArticleInfo.updateAt,
              isPost: 1
            }
            this.updatePictureActivityArticleAsync(val)
          }
          let pictureIds = []
          let imageList = []
          // if(this.$route.query.isColumn == 'true') {
          //   pictureIds = this.choosePic
          // }else {
          this.choosePic.forEach((e) => {
            pictureIds.push(e.id)
            imageList.push({
              id: e.id,
              desc: e.desc
            })
          })
          // }
          // console.log(imageList);

          this.ruleForm.content.imageList = imageList
          this.ruleForm.content.text = this.ruleForm.textValue

          this.ruleForm.content = JSON.stringify(this.ruleForm.content)

          if (this.ruleForm.id) {
            this.ruleForm.pictureIds = pictureIds.toString()
            this.ruleForm.releaseAt = this.ruleForm.releaseAt / 1000
            this.ruleForm.author = this.penName
            this.updateWebsiteShowInfoAsync(this.ruleForm)
          } else {
            let val = {
              columnId: this.ruleForm.columnId,
              title: this.ruleForm.title,
              desc: this.ruleForm.desc,
              content: this.ruleForm.content,
              status: this.ruleForm.status,
              releaseAt: this.ruleForm.status == '2' ? this.ruleForm.releaseAt / 1000 : null,
              infoType: 'atlas',
              videoIds: 0,
              pictureIds: pictureIds.toString(),
              createUid: this.createUid,
              isRecommend: this.ruleForm.isRecommend,
              indexpicFileId: this.ruleForm.indexpicFileId ? this.ruleForm.indexpicFileId : this.choosePic[0].id,
              activityArticleId: this.$route.query.activityArticleId,
              author: this.penName
            }
            this.addWebsiteShowInfoAsync(val)
          }
          // console.log(123);
          if (this.$route.query.isSavePic == 'false') {
            if (this.$route.query.isDrawer == 'false') {
              // console.log(789789);
              let allLovePic = JSON.parse(sessionStorage.getItem("picLove"));
              let chooseLovePic = JSON.parse(sessionStorage.getItem("chooseArr"));
              allLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });
              chooseLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });

              let nowLovePic = allLovePic
              for (let i = 0; i < allLovePic.length; i++) {
                for (let j = 0; j < chooseLovePic.length; j++) {
                  if (chooseLovePic[j].id == allLovePic[i].id) {
                    nowLovePic.splice(i, 1)
                  }
                }
              }
              let idsInfo = []
              for (let k = 0; k < nowLovePic.length; k++) {
                idsInfo.push({
                  id: nowLovePic[k].id,
                })
              }
              this.setLoveList(nowLovePic)
              sessionStorage.setItem("picLove", JSON.stringify(nowLovePic));
              this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
            } else {
              // console.log(131415);
              let loveList = []
              this.setLoveList(loveList)
              sessionStorage.removeItem("picLove");
              this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
            }
          }
        } else {
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    closeForm () {
      this.$router.go(-1)
      // if(this.isAct === true){
      //   this.$router.go(-1)
      // }else{
      //   this.$emit('closeForm')
      // }
    },

    picDelete (item, i) {
      this.$confirm('确认删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.choosePic.splice(i, 1)
          this.$forceUpdate()
          // this.choosePic.splice(i,1)
        })
        .catch(e => {

        });
    },
    picFm (item, i) {
      this.$confirm('确认设为封面吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.ruleForm.indexpicFileId = item.id
          this.$forceUpdate()
          // this.choosePic.splice(i,1)
        })
        .catch(e => {

        });
    },


    quickFormat () {
      var content_arr = this.ruleForm.text.replace("\r", "").split("\n");
      var tempcontent = '';
      for (var i = 0; i < content_arr.length; i++) {
        if (content_arr[i].trim() !== "") {
          var temp = "  " + content_arr[i].trim() + "\n\n";
          tempcontent = tempcontent + temp;
        }
      }
      this.ruleForm.text = tempcontent
    },

    //设置选用图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取频道和栏目类别
    async listWebsiteColumnAsync (val) {
      let { status, data, message, pagination, errors } = await listWebsiteColumn(val);
      if (status) {
        this.columnList = []
        for (let i = 0; i < data.length; i++) {
          this.columnList.push({
            value: data[i].id,
            label: data[i].name,
            level: 1,
            children: []
          })
        }
        let next = []
        for (let i = 0; i < this.columnList.length; i++) {
          let childVal = {
            page: 0,
            pageSize: 50,
            parentId: this.columnList[i].value
          }
          let dataChildren = await listWebsiteColumn(childVal);
          if (dataChildren.data.length > 0) {
            for (let j = 0; j < dataChildren.data.length; j++) {
              this.columnList[i].children.push({
                value: dataChildren.data[j].id,
                label: dataChildren.data[j].name,
                level: 2
              })
            }
          }
        }

        this.columnList = this.columnList.concat(next)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }

    },
    //获取图集中所有图片
    async listAtlasPicturesAsync () {
      let { status, data, message, errors } = await listAtlasPictures({ id: this.$route.query.id, page: 0, pageSize: 100 });
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].fileInfo.picThumbH160) {
            data[i].src = picPrefix + data[i].fileInfo.picThumbH160
          } else {
            data[i].src = picPrefix + data[i].fileInfo.savepath
          }
          if (this.choosePic[i].resourceId) {
            // this.choosePic[i].id = this.choosePic[i].resourceId
            if (this.choosePic[i].resourceId) {
              this.choosePic[i].id = this.choosePic[i].resourceId
            }
          }
        }
        this.choosePic = data

        this.ruleForm.indexpicFileId = this.choosePic[0].id
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改封面图
    async updateFengMian (val) {
      let { status, data, message, errors } = await updateWebsiteShowInfo(
        val
      );
      if (status) {
        this.$message.success('修改成功！')
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改
    async updateWebsiteShowInfoAsync (val) {
      let { status, data, message, errors } = await updateWebsiteShowInfo(
        val
      );
      if (status) {
        this.$message.success('修改成功！')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1000);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //获取信息
    async getWebsiteShowInfoAsync (val) {
      let { status, data, message, errors } = await getWebsiteShowInfo(val);
      if (status) {
        this.ruleForm = data
        this.ruleForm.content = JSON.parse(this.ruleForm.content)
        this.ruleForm.textValue = this.ruleForm.content.text
        console.log(data);
        this.ruleForm.status = this.ruleForm.status.toString()
        this.ruleForm.releaseAt = this.ruleForm.releaseAt * 1000
        this.getPicturesAsync({ ids: data.pictureIds })
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //批量获取图片
    async getPicturesAsync (val, text) {
      let { status, data, message, errors } = await getPictures(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].fileInfo.picThumbH160) {
            data[i].src = picPrefix + data[i].fileInfo.picThumbH160
            data[i].srcW1080 = picPrefix + data[i].fileInfo.picThumbW1080
          } else {
            data[i].src = picPrefix + data[i].fileInfo.savepath
            data[i].srcW1080 = picPrefix + data[i].fileInfo.savepath
          }
          // this.choosePic[i].id = this.choosePic[i].resourceId
          try {
            if (this.choosePic[i].resourceId) {
              this.choosePic[i].id = this.choosePic[i].resourceId
            }
          } catch (error) {

          }

          // if (this.choosePic[i].resourceId) {
          //   this.choosePic[i].id = this.choosePic[i].resourceId
          // }
        }
        this.choosePic = data

        if (text) {
          this.ruleForm.indexpicFileId = this.choosePic[0].id
        }

        for (let i = 0; i < this.ruleForm.content.imageList.length; i++) {
          this.choosePic[i].desc = this.ruleForm.content.imageList[i].desc
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建展示信息
    async addWebsiteShowInfoAsync (val) {
      let { status, data, message, errors } = await addWebsiteShowInfo(val);
      if (status) {
        this.$message.success('创建成功！')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1000);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

  },
  created () {
    this.getPictureActivityArticleAsync()
    if (localStorage.getItem('activityArticleInfo')) {
      this.activityArticleInfo = JSON.parse(localStorage.getItem('activityArticleInfo'))
      if (this.activityArticleInfo.penName) {
        this.penName = this.activityArticleInfo.penName
      } else {
        this.penName = this.activityArticleInfo.actUser
      }
      if (this.$route.query.isDrawer == 'true') {
        this.penName = ""
      }
      if(this.$route.query.isSavePic){
        this.ruleForm.columnId = ''
      }else{
        if (this.activityArticleInfo.columnInfo) {
          this.ruleForm.columnId = this.activityArticleInfo.columnInfo.id
        } else {
          this.ruleForm.columnId = ''
        }
      }
    }

    
    if (this.$route.query.actName) {
      this.penName = this.$route.query.actName
    }

    let val = {
      page: 0,
      pageSize: 50,
      parentId: 0
    }
    this.listWebsiteColumnAsync(val)

    let loginInfoString = localStorage.getItem("loginInfo");
    let loginInfoeArray = JSON.parse(loginInfoString)

    this.ruleForm.author = loginInfoeArray.name
    let isDrawer
    let isAct

    if (this.$route.query.isDrawer) {
      isDrawer = this.$route.query.isDrawer
      if (isDrawer === 'false') {
        isDrawer = false
      } else if (isDrawer === 'true') {
        isDrawer = true
      }
      if (isDrawer) {
        let picLoveString = sessionStorage.getItem("picLove");
        this.choosePic = JSON.parse(picLoveString)
        for (let i = 0; i < this.choosePic.length; i++) {
          if (this.choosePic[i].resourceId) {
            this.choosePic[i].id = this.choosePic[i].resourceId
          }
        }
        this.ruleForm.indexpicFileId = this.choosePic[0].id
      }
    }

    if (this.$route.query.isSwitch) {
      let isSwitch = this.$route.query.isSwitch
      if (isSwitch === 'false') {
        isSwitch = false
      } else if (isSwitch === 'true') {
        isSwitch = true
      }
      if (!isSwitch) {
        let picLoveString = sessionStorage.getItem("chooseArr");
        this.choosePic = JSON.parse(picLoveString)
        for (let i = 0; i < this.choosePic.length; i++) {
          // this.choosePic[i].desc = ""
          if (this.choosePic[i].resourceId) {
            this.choosePic[i].id = this.choosePic[i].resourceId
          }
        }
        this.ruleForm.indexpicFileId = this.choosePic[0].id
      }
    }
    if (this.$route.query.isUseActivity == 'true') {
      let picLoveString = sessionStorage.getItem("chooseArr");
      this.choosePic = JSON.parse(picLoveString)
      for (let i = 0; i < this.choosePic.length; i++) {
        // this.choosePic[i].desc = ""
        if (this.choosePic[i].resourceId) {
          this.choosePic[i].id = this.choosePic[i].resourceId
        }
        // this.choosePic[i].src = this.choosePic[i].fileInfo.scr
      }
      this.ruleForm.indexpicFileId = this.choosePic[0].id
    }
    if (this.$route.query.isColumn == 'true' || this.$route.query.isActivity == 'true') {
      let picLoveString = sessionStorage.getItem("actPic");
      this.choosePic = JSON.parse(picLoveString)
      for (let i = 0; i < this.choosePic.length; i++) {
        // this.choosePic[i].desc = ""
        if (this.choosePic[i].resourceId) {
          this.choosePic[i].id = this.choosePic[i].resourceId
        }
        this.choosePic[i].src = this.choosePic[i].fileInfo.scr
      }
      this.ruleForm.indexpicFileId = this.choosePic[0].id
    }



    if (this.$route.query.isChange) {
      this.getWebsiteShowInfoAsync(this.$route.query.changeId)
    }

    if (this.$route.query.ids) {
      this.getPicturesAsync({ ids: this.$route.query.ids }, 'upload')
    }
    // if(this.$route.query.isAct){
    //   isAct = this.$route.query.isAct
    //   this.isAct = isAct
    //   if(isAct === 'false'){
    //     isAct = false
    //   }else if(isAct === 'true'){
    //     isAct = true
    //   }

    //   if(isAct){
    //     let picLoveString = sessionStorage.getItem("actPic");
    //     this.choosePic = JSON.parse(picLoveString)
    //     for (let i = 0; i < this.choosePic.length; i++) {
    //       this.choosePic[i].desc = ""
    //     }
    //     console.log(this.choosePic)
    //   }
    // }

    if (this.$route.query.id) {
      this.listAtlasPicturesAsync()
    }


  },
  mounted () {
    // 拖拽图片
    // this.$dragging.$on("dragged", val => {
    //   console.log("val---->", val);
    // });
    // this.$dragging.$on("dragend", val => {
    //   //此处是拖动完成后鼠标松开时触发的事件
    //   console.log(this.choosePic);
    // });
  }
}
</script>

<style lang="scss" scoped>
.picbj {
  padding-top: 20px;
  padding-left: 90px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  grid-gap: 10px;
  // display: flex;
  // justify-content: space-between;
  // flex-wrap: wrap;
  &:after {
    content: "";
    width: 31%;
    border: 1px solid transparent;
  }
  .picanddesc {
    // float: left;
    display: flex;
    align-items: center;
    width: 500px;
    margin-bottom: 20px;

    .pic {
      width: 130px;
      height: 130px;
      border-radius: 6px;
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;
      /deep/ .el-image {
        width: 100%;
        height: 100%;
      }
      &:hover .delete {
        opacity: 1;
      }
      .delete {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.6);
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        transition: 0.3s;
        opacity: 0;
      }
      &:hover .fm {
        opacity: 1;
      }
      .fm {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.6);
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        transition: 0.3s;
        opacity: 0;
      }
      .fengmian {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.6);
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        transition: 0.3s;
      }
    }
  }
}
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // top: 0;
  // z-index: 99;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn /deep/ .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn /deep/ .el-button--primary {
  background-color: #185ed3;
}
/deep/ .el-form-item__label {
  font-weight: 600;
}

.el-radio.is-checked /deep/ .el-radio__label {
  color: #606266 !important;
}
/* 选中后小圆点的颜色 */
.el-radio.is-checked /deep/ .el-radio__inner {
  background: #3cb035 !important;
  border-color: #3cb035 !important;
}
</style>
